/**
 * Created by Mark on 22/04/2017.
 */

import ApplicationServices from './base-service.js';
import Constants from '../constants.js';
import Action from '../application-actions.js';
import Translation from '../store/internationalization-store.js';

class CatalogService {

    getCatalogVocab(catalogUid , toLanguage, fromLanguage){

        if (fromLanguage == undefined || fromLanguage == "undefined") {
            fromLanguage = Translation.locale
        }

        return ApplicationServices.call(Constants.GET_CATALOG_VOCAB , {catalogUIDs:catalogUid , toLanguage:toLanguage , fromLanguage:fromLanguage}).then(function(response){
            Action.update('ON_CATALOG_UPDATE' , response.allVocabs)
            return response.allVocabs;
        });

    }

    getExamQuestion(gameUid , examUid , toLanguage , fromLanguage){

        return ApplicationServices.call(Constants.GET_EXAM_CATALOG , {gameId:gameUid , gameUid:gameUid , examUid:examUid , toLanguage:toLanguage , fromLanguage:fromLanguage}).then(function(response){
            return response;
        });

    }

    getExamUID(exam_catalog){

        return ApplicationServices.call(Constants.GET_EXAM_UID , {examUid:exam_catalog}).then(function(response){
            return response.exams;
        });
    }

    getExamDataQuestion(gameUid , examUid , toLanguage , fromLanguage)
    {
        return ApplicationServices.call(Constants.GET_EXAM_DATA , {toIetf:fromLanguage , fromIetf:toLanguage , examUid:examUid}).then(function(response){
            return response;
        });
    }
}

export default new CatalogService();